<template>
  <div class="pingjia">
    <el-card>
      <el-form :model="form" :rules="rules" ref="ruleForm" class="form_pj">
      <el-form-item label="满意度评价：" prop="value">
        <el-rate  v-model="form.value" :texts="mydpj" show-text></el-rate>
      </el-form-item>
      <el-form-item label="评价内容：" prop="comments">
      <el-input type="textarea" placeholder="请输入评价内容" maxlength="50" show-word-limit rows="5" v-model.trim="form.comments"></el-input>
    </el-form-item>
    </el-form>
    </el-card>
    <button class="btn_bind" style="width:100%" type="button" @click="submit">提 交</button>
  </div>
</template>

<script>
import { pj } from '@/api'
import {getQueryVariable} from "@/utils";
export default {
  data() {
    return {
      form: {

      },
      ordersn: this.$route.query.ordersn,
      taskId: this.$route.query.taskId,
      comments: '',
      mydpj: ['极差', '失望', '一般', '满意', '非常满意'],
      rules: {
          value: [
            { required: true, message: '请您评价完再提交', trigger: 'change' }
          ],
          comments: [
            { required: true, message: '请您评价完再提交', trigger: 'blur' }
          ]
      }
    };
  },
  mounted() {
  },
  methods: {
    submit() {
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            let params = {
              comments: this.form.comments,
              satisfy: this.form.value===0?'极差':this.mydpj[this.form.value-1],
              taskId: this.$route.params.taskId
            }
            pj(params).then(res=>{
              if(sessionStorage.getItem('companyCode')) {
                this.$router.go(-1)
              } else {
                this.$toast('评价成功')
              }

            })
          } else {
            return false
          }
        })
    },
  },
};
</script>

<style scoped>
.pingjia {
  /* height: 100%; */
  background: #fff;
  padding: 10px 3%;
  /* text-align: center; */
}
.rate {
  display: inline-block;
  margin-top: 50px;
}
.btn_pj {
  width: 90%;
  margin: 60px 5%;
}
.comments{
  width: 94%;
  margin-left: 3%;
}
.form_pj{
  padding: 3%;
}
</style>



// WEBPACK FOOTER //
// src/view/ywbl/bx/pingjia.vue